module.exports = __webpack_public_path__ + "img/ava-1.6cf53fd4.png";